/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateQueueSessionInput
 */
export interface CreateQueueSessionInput {
    /**
     * 
     * @type {string}
     * @memberof CreateQueueSessionInput
     */
    projectId?: string;
    /**
     * 
     * @type {CreateQueueSessionInputModeEnum}
     * @memberof CreateQueueSessionInput
     */
    mode?: CreateQueueSessionInputModeEnum;
    /**
     * 
     * @type {CreateQueueSessionInputFetchWindowEnum}
     * @memberof CreateQueueSessionInput
     */
    fetchWindow?: CreateQueueSessionInputFetchWindowEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreateQueueSessionInput
     */
    since?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateQueueSessionInput
     */
    until?: Date | null;
    /**
     * ISO 8601 instant with a required timezone offset or Z suffix.
     * @type {Date}
     * @memberof CreateQueueSessionInput
     */
    plannedFor?: Date | null;
}


/**
 * @export
 */
export const CreateQueueSessionInputModeEnum = {
    Regular: 'regular',
    Maintenance: 'maintenance',
    Minimal: 'minimal',
    Finalize: 'finalize',
    Manual: 'manual'
} as const;
export type CreateQueueSessionInputModeEnum = typeof CreateQueueSessionInputModeEnum[keyof typeof CreateQueueSessionInputModeEnum];

/**
 * @export
 */
export const CreateQueueSessionInputFetchWindowEnum = {
    Day: 'day',
    Week: 'week',
    TwoWeeks: 'two_weeks',
    Month: 'month',
    TwoMonths: 'two_months',
    HalfYear: 'half_year',
    Year: 'year',
    Custom: 'custom'
} as const;
export type CreateQueueSessionInputFetchWindowEnum = typeof CreateQueueSessionInputFetchWindowEnum[keyof typeof CreateQueueSessionInputFetchWindowEnum];


/**
 * Check if a given object implements the CreateQueueSessionInput interface.
 */
export function instanceOfCreateQueueSessionInput(value: object): value is CreateQueueSessionInput {
    return true;
}

export function CreateQueueSessionInputFromJSON(json: any): CreateQueueSessionInput {
    return CreateQueueSessionInputFromJSONTyped(json, false);
}

export function CreateQueueSessionInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateQueueSessionInput {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'fetchWindow': json['fetchWindow'] == null ? undefined : json['fetchWindow'],
        'since': json['since'] === undefined ? undefined : json['since'] === null ? null : (new Date(json['since'])),
        'until': json['until'] === undefined ? undefined : json['until'] === null ? null : (new Date(json['until'])),
        'plannedFor': json['plannedFor'] === undefined ? undefined : json['plannedFor'] === null ? null : (new Date(json['plannedFor'])),
    };
}

export function CreateQueueSessionInputToJSON(json: any): CreateQueueSessionInput {
    return CreateQueueSessionInputToJSONTyped(json, false);
}

export function CreateQueueSessionInputToJSONTyped(value?: CreateQueueSessionInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectId': value['projectId'],
        'mode': value['mode'],
        'fetchWindow': value['fetchWindow'],
        'since': value['since'] == null ? value['since'] : value['since'].toISOString().substring(0,10),
        'until': value['until'] == null ? value['until'] : value['until'].toISOString().substring(0,10),
        'plannedFor': value['plannedFor'] == null ? value['plannedFor'] : value['plannedFor'].toISOString(),
    };
}

